import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Body } from '../op-types';

export function createChatbotQueries(client: StoxlyClient) {
  return createQueryKeys('chatbot', {
    // ['chatbot', 'models']
    models: {
      queryKey: null,
      queryFn: ({ signal }) => client.chatbotGetModels({ signal }),
    },
  });
}

export function createChatbotMutations(client: StoxlyClient) {
  return {
    stream: {
      mutationFn: (body: Body<'chatbotStream'>) => client.chatbotStream(body),
    },
    // Compact a thread's model memory (plan §1.3): summary + boundary advance; rows untouched.
    compactThread: {
      mutationFn: (id: string) => client.chatbotCompactThread(undefined, { params: { id } }),
    },
    // AI retitle from the conversation as it now stands (plan §1.5) — not a chat turn.
    retitleThread: {
      mutationFn: (id: string) => client.chatbotRetitleThread(undefined, { params: { id } }),
    },
    // Stop the thread's live turn wherever it runs and resolve once its partial is persisted
    // (≤5 s). The socket closing no longer aborts a turn (generation survives a disconnect),
    // so this is the ONLY way a user stop reaches the server — `chat.stop()` alone just stops
    // listening. The reconnect GET is not here: the AI SDK's `resumeStream()` fetches it itself.
    stopThread: {
      mutationFn: (id: string) => client.chatbotStopThread(undefined, { params: { id } }),
    },
    // The live-turn replay (200 SSE, or 204 when nothing runs). Like `stream` above, the AI
    // SDK transport fetches this itself (`resumeStream()` → `reconnectToStream`); it is listed
    // here so the spine documents the endpoint and the coverage gate sees it consumed.
    resumeThreadStream: {
      mutationFn: (id: string) => client.chatbotResumeThreadStream({ params: { id } }),
    },
  };
}
